"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_i18next_1 = require("react-i18next");
var client_1 = __importDefault(require("stremio/caroline/auth/client"));
var useCarolineSession_1 = __importDefault(require("stremio/caroline/auth/useCarolineSession"));
var styles_less_1 = __importDefault(require("./styles.less"));
var authErrorMessage = function (code, mode, t) {
    if (code === 'USER_ALREADY_EXISTS' || code === 'USER_ALREADY_EXISTS_USE_ANOTHER_EMAIL') {
        return t('CAROLINE_AUTH_EMAIL_EXISTS', { defaultValue: 'Já existe uma conta com este email.' });
    }
    if (mode === 'sign-in' && ['INVALID_EMAIL_OR_PASSWORD', 'INVALID_PASSWORD', 'USER_NOT_FOUND'].includes(code !== null && code !== void 0 ? code : '')) {
        return t('CAROLINE_AUTH_INVALID_CREDENTIALS', { defaultValue: 'Email ou palavra-passe incorrectos.' });
    }
    return t('CAROLINE_AUTH_FAILED', { defaultValue: 'Não foi possível autenticar. Tenta novamente.' });
};
var CarolineAuth = function () {
    var _a, _b, _c;
    var t = (0, react_i18next_1.useTranslation)().t;
    var location = (0, react_router_dom_1.useLocation)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var session = (0, useCarolineSession_1.default)();
    var _d = react_1.default.useState('sign-in'), mode = _d[0], setMode = _d[1];
    var _e = react_1.default.useState(''), name = _e[0], setName = _e[1];
    var _f = react_1.default.useState(''), email = _f[0], setEmail = _f[1];
    var _g = react_1.default.useState(''), password = _g[0], setPassword = _g[1];
    var _h = react_1.default.useState(false), submitting = _h[0], setSubmitting = _h[1];
    var _j = react_1.default.useState(null), message = _j[0], setMessage = _j[1];
    react_1.default.useEffect(function () {
        if (session.status !== 'authenticated')
            return;
        var returnTo = new URLSearchParams(location.search).get('returnTo');
        if ((returnTo === '/device' || (returnTo === null || returnTo === void 0 ? void 0 : returnTo.startsWith('/device?user_code='))) && !returnTo.includes('//')) {
            navigate(returnTo, { replace: true });
        }
    }, [location.search, navigate, session.status]);
    var onSubmit = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var result, _a, _1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    event.preventDefault();
                    setMessage(null);
                    setSubmitting(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, 7, 8]);
                    if (!(mode === 'sign-up')) return [3 /*break*/, 3];
                    return [4 /*yield*/, client_1.default.signUp.email({ name: name, email: email, password: password })];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, client_1.default.signIn.email({ email: email, password: password })];
                case 4:
                    _a = _b.sent();
                    _b.label = 5;
                case 5:
                    result = _a;
                    if (result.error) {
                        setMessage(authErrorMessage(result.error.code, mode, t));
                    }
                    return [3 /*break*/, 8];
                case 6:
                    _1 = _b.sent();
                    setMessage(t('CAROLINE_AUTH_UNAVAILABLE', { defaultValue: 'O serviço Caroline Auth não está disponível.' }));
                    return [3 /*break*/, 8];
                case 7:
                    setSubmitting(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var onSignOut = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result, _2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setMessage(null);
                    setSubmitting(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, client_1.default.signOut()];
                case 2:
                    result = _a.sent();
                    if (result.error) {
                        setMessage(t('CAROLINE_AUTH_SIGN_OUT_FAILED', { defaultValue: 'Não foi possível terminar a sessão. Tenta novamente.' }));
                    }
                    return [3 /*break*/, 5];
                case 3:
                    _2 = _a.sent();
                    setMessage(t('CAROLINE_AUTH_UNAVAILABLE', { defaultValue: 'O serviço Caroline Auth não está disponível.' }));
                    return [3 /*break*/, 5];
                case 4:
                    setSubmitting(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    if (session.status === 'loading') {
        return react_1.default.createElement("main", { className: styles_less_1.default.authPage },
            react_1.default.createElement("p", { role: "status" }, t('CAROLINE_AUTH_CHECKING_SESSION', { defaultValue: 'A verificar sessão Caroline…' })));
    }
    if (session.status === 'authenticated') {
        return (react_1.default.createElement("main", { className: styles_less_1.default.authPage },
            react_1.default.createElement("section", { className: styles_less_1.default.authPanel, "aria-labelledby": "caroline-auth-title" },
                react_1.default.createElement("p", { className: styles_less_1.default.eyebrow }, t('CAROLINE_AUTH_ACCOUNT', { defaultValue: 'Conta Caroline' })),
                react_1.default.createElement("h1", { id: "caroline-auth-title" }, t('CAROLINE_AUTH_SESSION_ACTIVE', { defaultValue: 'Sessão activa' })),
                react_1.default.createElement("p", { className: styles_less_1.default.accountName }, ((_a = session.user) === null || _a === void 0 ? void 0 : _a.name) || ((_b = session.user) === null || _b === void 0 ? void 0 : _b.email)),
                ((_c = session.user) === null || _c === void 0 ? void 0 : _c.name) && react_1.default.createElement("p", { className: styles_less_1.default.accountEmail }, session.user.email),
                message && react_1.default.createElement("p", { className: styles_less_1.default.error, role: "alert" }, message),
                react_1.default.createElement("button", { className: styles_less_1.default.primaryButton, type: "button", onClick: onSignOut, disabled: submitting }, submitting
                    ? t('CAROLINE_AUTH_SIGNING_OUT', { defaultValue: 'A terminar sessão…' })
                    : t('CAROLINE_AUTH_SIGN_OUT', { defaultValue: 'Terminar sessão' })))));
    }
    return (react_1.default.createElement("main", { className: styles_less_1.default.authPage },
        react_1.default.createElement("section", { className: styles_less_1.default.authPanel, "aria-labelledby": "caroline-auth-title" },
            react_1.default.createElement("p", { className: styles_less_1.default.eyebrow }, t('CAROLINE_AUTH_ACCOUNT', { defaultValue: 'Conta Caroline' })),
            react_1.default.createElement("h1", { id: "caroline-auth-title" }, mode === 'sign-up'
                ? t('CAROLINE_AUTH_CREATE_ACCOUNT', { defaultValue: 'Criar conta' })
                : t('CAROLINE_AUTH_SIGN_IN', { defaultValue: 'Iniciar sessão' })),
            react_1.default.createElement("div", { className: styles_less_1.default.modeSwitch, "aria-label": t('CAROLINE_AUTH_MODE', { defaultValue: 'Tipo de autenticação' }) },
                react_1.default.createElement("button", { className: mode === 'sign-in' ? styles_less_1.default.modeActive : styles_less_1.default.modeButton, type: "button", "aria-pressed": mode === 'sign-in', onClick: function () { setMode('sign-in'); setMessage(null); } }, t('CAROLINE_AUTH_SIGN_IN', { defaultValue: 'Iniciar sessão' })),
                react_1.default.createElement("button", { className: mode === 'sign-up' ? styles_less_1.default.modeActive : styles_less_1.default.modeButton, type: "button", "aria-pressed": mode === 'sign-up', onClick: function () { setMode('sign-up'); setMessage(null); } }, t('CAROLINE_AUTH_CREATE_ACCOUNT', { defaultValue: 'Criar conta' }))),
            react_1.default.createElement("form", { className: styles_less_1.default.authForm, onSubmit: onSubmit },
                mode === 'sign-up' && (react_1.default.createElement("label", { className: styles_less_1.default.field },
                    react_1.default.createElement("span", null, t('CAROLINE_AUTH_NAME', { defaultValue: 'Nome' })),
                    react_1.default.createElement("input", { autoComplete: "name", name: "name", required: true, value: name, onChange: function (event) { return setName(event.target.value); } }))),
                react_1.default.createElement("label", { className: styles_less_1.default.field },
                    react_1.default.createElement("span", null, t('CAROLINE_AUTH_EMAIL', { defaultValue: 'Email' })),
                    react_1.default.createElement("input", { autoComplete: "email", name: "email", type: "email", required: true, value: email, onChange: function (event) { return setEmail(event.target.value); } })),
                react_1.default.createElement("label", { className: styles_less_1.default.field },
                    react_1.default.createElement("span", null, t('CAROLINE_AUTH_PASSWORD', { defaultValue: 'Palavra-passe' })),
                    react_1.default.createElement("input", { autoComplete: mode === 'sign-up' ? 'new-password' : 'current-password', name: "password", type: "password", minLength: 8, maxLength: 128, required: true, value: password, onChange: function (event) { return setPassword(event.target.value); } })),
                session.status === 'unavailable' && react_1.default.createElement("p", { className: styles_less_1.default.error, role: "alert" }, t('CAROLINE_AUTH_UNAVAILABLE', { defaultValue: 'O serviço Caroline Auth não está disponível.' })),
                message && react_1.default.createElement("p", { className: styles_less_1.default.error, role: "alert" }, message),
                react_1.default.createElement("button", { className: styles_less_1.default.primaryButton, type: "submit", disabled: submitting || session.status === 'unavailable' }, submitting
                    ? t('CAROLINE_AUTH_PROCESSING', { defaultValue: 'A processar…' })
                    : mode === 'sign-up'
                        ? t('CAROLINE_AUTH_CREATE_ACCOUNT_CTA', { defaultValue: 'Criar conta Caroline' })
                        : t('CAROLINE_AUTH_SIGN_IN', { defaultValue: 'Iniciar sessão' }))))));
};
exports.default = CarolineAuth;
